"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ListItemMixin = require("../../mixins/components/ListItemMixin");
/**
 * @since 8.14.0
 */
var ListItem = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "ListItem",
  componentId: "c11n-8-107-0__sc-13rwu5a-0"
})(["", ""], _ListItemMixin.ListItemMixin);
exports.ListItem = ListItem;
ListItem.displayName = 'ListItem';
ListItem.defaultProps = {
  paddingY: 'xs'
};

/** @component */